export const CHALLENGE_OPTIONS = [
    {
        label: "Seulement challenges",
        value: "only",
    },
    {
        label: "Exclure challenges",
        value: "exclude",
    },
];
